import { Injectable } from "@angular/core";
import { AnimationController } from "@ionic/angular";

@Injectable({
  providedIn: "root",
})
export class CustomModalTransitionService {
  constructor(private animationCtrl: AnimationController) {}

  enterFromRight = (baseEl: HTMLElement) => {
    const root = baseEl.shadowRoot;
    
    // Add null safety checks for modal elements
    const backdropElement = root?.querySelector("ion-backdrop");
    const wrapperElement = root?.querySelector(".modal-wrapper");
    
    // If elements don't exist, return a zero-duration animation to prevent errors
    if (!backdropElement || !wrapperElement) {
      return this.animationCtrl
        .create()
        .addElement(baseEl)
        .duration(0);
    }

    const backdropAnimation = this.animationCtrl
      .create()
      .addElement(backdropElement)
      .fromTo("opacity", "0.01", "var(--backdrop-opacity)");

    const wrapperAnimation = this.animationCtrl
      .create()
      .addElement(wrapperElement)
      .fromTo("transform", "translateX(100%)", "translateX(0)")
      .fromTo("opacity", "var(--backdrop-opacity)", "1");

    return this.animationCtrl
      .create()
      .addElement(baseEl)
      .duration(500)
      .addAnimation([backdropAnimation, wrapperAnimation]);
  };

  exitThroughRight = (baseEl: HTMLElement) => {
    return this.enterFromRight(baseEl).direction("reverse");
  };
}
